
// document.addEventListener("change", function (event) {
//   const radio = event.target.closest(
//     "fieldset.js.product-form__input input[type='radio']"
//   );

//   if (!radio) return;

//   const parentElem = radio.closest(".js-card-wrapper");
//   if (!parentElem) return;

//   let text = "";

//   parentElem
//     .querySelectorAll(".product-form__input input[type='radio']:checked")
//     .forEach(function (input) {
//       text += input.value;
//     });

//   const variant = parentElem.querySelector(
//     `span.variant_list[var-title="${CSS.escape(text)}"]`
//   );

//   if (!variant) return;

//   const varId = variant.getAttribute("var-id");
//   const variantAvailability = variant.getAttribute("avaibility");

//   const variantInput = parentElem.querySelector(".product-variant-id");

//   if (variantInput) {
//     variantInput.value = varId;
//   }

//   const submitBtn = parentElem.querySelector(
//     "product-form .quick-add__submit"
//   );

//   if (!submitBtn) return;

//   const submitSpan = submitBtn.querySelector(".add-to_cart");
//   const isAvailable = variantAvailability === "true";

//   if (variantInput) {
//     variantInput.disabled = !isAvailable;
//   }

//   submitBtn.disabled = !isAvailable;

//   const buttonText = isAvailable ? "Add to cart" : "Sold out";

//   if (submitSpan) {
//     submitSpan.textContent = buttonText;
//   } else {
//     submitBtn.textContent = buttonText;
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-card-wrapper').forEach(function (card) {
    updateVariantOptions(card);
  });
});

document.addEventListener('change', function (event) {
  const radio = event.target.closest(
    "fieldset.js.product-form__input input[type='radio']"
  );

  if (!radio) return;

  const parentElem = radio.closest('.js-card-wrapper');
  if (!parentElem) return;

  /* ---------------------------------
     GET CURRENT SELECTED VARIANT
  --------------------------------- */
  let text = '';

  parentElem
    .querySelectorAll(
      ".product-form__input input[type='radio']:checked"
    )
    .forEach(function (input) {
      text += input.value;
    });

  const variant = parentElem.querySelector(
    `span.variant_list[var-title="${CSS.escape(text)}"]`
  );

  if (variant) {
    const varId = variant.getAttribute('var-id');
    const variantAvailability = variant.getAttribute('avaibility');

    const variantInput = parentElem.querySelector(
      '.product-variant-id'
    );

    const submitBtn = parentElem.querySelector(
      'product-form .quick-add__submit'
    );

    if (variantInput) {
      variantInput.value = varId;
    }

    if (submitBtn) {
      const submitSpan = submitBtn.querySelector('.add-to_cart');
      const isAvailable = variantAvailability === 'true';

      if (variantInput) {
        variantInput.disabled = !isAvailable;
      }

      submitBtn.disabled = !isAvailable;

      if (submitSpan) {
        submitSpan.textContent = isAvailable
          ? 'Add to cart'
          : 'Sold out';
      }
    }
  }

  /* ---------------------------------
     UPDATE SOLD OUT OPTIONS
  --------------------------------- */
  updateVariantOptions(parentElem);
});


function updateVariantOptions(parentElem) {
  const fieldsets = Array.from(
    parentElem.querySelectorAll(
      'fieldset.js.product-form__input'
    )
  );

  const variants = Array.from(
    parentElem.querySelectorAll('.variant_list')
  );

  if (!fieldsets.length || !variants.length) return;


  fieldsets.forEach(function (currentFieldset, fieldsetIndex) {

    const radios = currentFieldset.querySelectorAll(
      "input[type='radio']"
    );

    radios.forEach(function (radio) {

      let variantTitle = '';

      fieldsets.forEach(function (fieldset, index) {

        let input;

        /*
         * Current fieldset:
         * test this option
         */
        if (index === fieldsetIndex) {
          input = radio;
        }

        /*
         * Other fieldsets:
         * use currently selected option
         */
        else {
          input = fieldset.querySelector(
            "input[type='radio']:checked"
          );
        }

        if (input) {
          variantTitle += input.value;
        }
      });


      const matchingVariant = variants.find(function (variant) {
        return variant.getAttribute('var-title') === variantTitle;
      });


      const label = parentElem.querySelector(
        `label[for="${CSS.escape(radio.id)}"]`
      );

      if (!label) return;


      /*
       * Variant doesn't exist OR is sold out
       */
      if (
        !matchingVariant ||
        matchingVariant.getAttribute('avaibility') !== 'true'
      ) {
        label.classList.add('sold-out-option');
      }

      /*
       * Available
       */
      else {
        label.classList.remove('sold-out-option');
      }

    });

  });
}
